// Maps a product code to the key masterParsers.pendingCall() uses for that
// product's slice of the `master/customer-pending-actions` response.
export const PENDING_CALL_KEY_BY_CODE = {
  PORTFOLIO: "portfolioData",
  RMS: "protectData",
  ONESTOCK: "onestockData",
  PRIME: "primeData",
  SENTIMENT: "sentimentData",
};

export const getProductPendingCall = (pendingCallData, code) =>
  pendingCallData?.[PENDING_CALL_KEY_BY_CODE[code]] || null;

export const hasProductPendingCall = (pendingCallData, product) =>
  Boolean(
    product &&
      !product.isLocked &&
      getProductPendingCall(pendingCallData, product.code)?.isPendingCall === 1,
  );

// Aggregate "pending call + plan expired" count masterParsers.pendingCall()
// computes per product, used as the badge popover's actionable count.
const PENDING_COUNT_KEY_BY_CODE = {
  PORTFOLIO: "portfolioPendingCount",
  RMS: "protectPendingCount",
  ONESTOCK: "onestockPendingCount",
  PRIME: "primePendingCount",
};

export const getProductPendingCount = (pendingCallData, code) =>
  pendingCallData?.[PENDING_COUNT_KEY_BY_CODE[code]] || 1;
